<script setup lang="ts">
/**
 * 発注ステータスバッジ
 */
import Mdi from '@/corePagesModule/components/Mdi.vue';
import { i18n } from '@/i18n';
import { computed } from 'vue';
import { DashboardAlertType } from '../domains/entities/DashboardAlert';

const props = withDefaults(
  defineProps<{
    alert?: DashboardAlertType;
    severity: 'warning' | 'critical';
    withIconName?: string;
  }>(),
  { alert: undefined, withIconName: undefined }
);
const t = i18n.t;

const alertLabelName = computed(() => (props.alert?.includes('forecast_sharp') ? `${props.severity}_${props.alert}` : props.alert));
</script>

<template>
  <div class="alert-badge">
    <div :class="`status-tag status-tag--${alertLabelName}`">
      <span>
        {{ alertLabelName ? t(alertLabelName) : '' }}
      </span>
      <Mdi v-if="props.withIconName" :icon="props.withIconName" class="status-tag__icon" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.alert-badge {
  padding: 2px;
}

.status-tag {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  column-gap: 8px;
  justify-content: center;
  align-items: center;
  width: max-content;
  border-radius: 90px;
  padding: 4px 8px;
  font-family: Noto Sans JP;
  font-size: $fontSizeSS;
  line-height: 12px;
  font-weight: 700;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &--warning_excess_forecast_sharp_decrease {
    color: #5c4300;
    background-color: #ffd84d;
  }
  &--critical_excess_forecast_sharp_decrease {
    color: #ffffff;
    background-color: #ff5a5a;
  }
  &--excess_forecast_consecutive_low {
    color: #ffffff;
    background-color: #38c172;
  }
  &--warning_shortage_forecast_sharp_increase {
    color: #003a70;
    background-color: #63b3ff;
  }
  &--critical_shortage_forecast_sharp_increase {
    color: #ffffff;
    background-color: #4d7dff;
  }
  &--shortage_forecast_consecutive_high {
    color: #ffffff;
    background-color: #b06bff;
  }
  &--shortage_forecast_current_high {
    color: #ffffff;
    background-color: #1e3a8a;
  }
  &--shortage_out_of_stock {
    color: #ffffff;
    background-color: #1f1f1f;
  }
  &__icon {
    font-size: 18px;
  }
}
</style>
